/**
 * Liturgical Day cycle that can be used as metadata for liturgical days.
 */
export enum LiturgicalDayCycle {
  TEMPORALE = 'TEMPORALE',
  SANCTORALE = 'SANCTORALE',
}

/**
 * Sundays cycle that can be used as metadata for liturgical days.
 */
export enum SundaysCycle {
  YEAR_A = 'YEAR_A',
  YEAR_B = 'YEAR_B',
  YEAR_C = 'YEAR_C',
}

/**
 * Weekdays cycle that can be used as metadata for liturgical days.
 */
export enum WeekdaysCycle {
  YEAR_1 = 'YEAR_1',
  YEAR_2 = 'YEAR_2',
}

/**
 * Psalter weeks that can be used as metadata for liturgical days.
 */
export enum PsalterWeeksCycle {
  WEEK_1 = 'WEEK_1',
  WEEK_2 = 'WEEK_2',
  WEEK_3 = 'WEEK_3',
  WEEK_4 = 'WEEK_4',
}
